import { trackPromise } from "react-promise-tracker";
import useProviders from "../../providers";

const useConfigurationServices = () => {
  const { useConfigurationProvider } = useProviders();
  const { getConfigurationProvider, saveConfigurationProvider } = useConfigurationProvider();

  const getConfigurationService = (key) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(getConfigurationProvider(key)));
      } catch (error) {
        reject(error);
      }
    });
  };

  const saveConfigurationService = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(saveConfigurationProvider(data)));
      } catch (error) {
        reject(error);
      }
    });
  };

  return {
    getConfigurationService,
    saveConfigurationService,
  };
};

export default useConfigurationServices;
